// extracted by mini-css-extract-plugin
module.exports = {"main":"search-form-cta_main__BGo2t","content":"search-form-cta_content__8vx7u","title":"search-form-cta_title__0B4VG","phAnimation":"search-form-cta_phAnimation__Df6yh"};